import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";
import ResponsiveStyleSheet from "react-native-media-query";

export const { styles, ids } = ResponsiveStyleSheet.create({
  panel: createResponsiveStyles({
    base: {
      marginBottom: theme.spacing.small,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingHorizontal: theme.spacing.small,
      paddingVertical: theme.spacing.small,
    },
    xsmall: {
      paddingVertical: theme.spacing.xsmall,
    },
  }),
  wrap: createResponsiveStyles({
    base: {
      width: "100%",
      alignItems: "center",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
    },
    medium: {
      justifyContent: "flex-start",
      flexWrap: "nowrap",
    },
  }),
  coins: createResponsiveStyles({
    base: {
      transform: [{ rotate: "-20deg" }],
      position: "absolute",
      left: theme.spacing.small,
    },
    xsmall: {
      position: "relative",
      left: 0,
    },
  }),

  button: createResponsiveStyles({
    base: {
      position: "relative",
      marginTop: theme.spacing.medium,
      width: "100%",
      textAlign: "center",
    },
    medium: { marginTop: 0, marginLeft: "auto", width: "auto" },
  }),
});
